import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { IButton } from 'src/common/interfaces/IButton';
import { POSModeState } from 'src/common/interfaces/states/POSModeState';
import { ReactComponent as Barcode } from 'src/common/media/barcode-h.svg';
import { AppState } from 'src/common/redux/configure-store';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import { ScannedDataHandler } from 'src/devices/scanner-operations';
import Keypad from 'src/keypad/components/keypad';
import ElectronicItemTitle from './electronic-item-title';
import { styles } from './electronic.item-styles';

type Props = IElectronicItemProps;
export const showElectronicItemScreen = (props: Props, scanCallback: ScannedDataHandler): void => {
  setHomePage(<ElectronicItemModal {...props} />, scanCallback);
};

const ElectronicItemModal: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const trainingModeClasses = trainingModeStyles();
  const posModeState = useSelector((state: AppState): POSModeState => state.posMode);
  const TARE_WEIGHT_KEYPAD_TOP_LABEL: string = t('POSKeyPadControl_SerialNumber');

  const keypadSubmitButton: IButton = {
    label: 'OK',
    onClick: props.onSubmit,
  };

  return (
    <Grid
      container
      className={`fullHeight flexFull fullWidth ${classes.wrapper} ${
        posModeState.trainingMode ? trainingModeClasses.trainingModeBackground : ''
      }`}
      data-testid='electronic-item'
    >
      <Grid item className={classes.header}>
        <ElectronicItemTitle title={t('ElectronicItem')} />
      </Grid>
      <Grid container className={classes.content}>
        <Grid item className={classes.main}>
          <Grid item className={classes.message}>
            <Grid item>
              <Typography variant='h4'>
                {t('AddExternalIdToElectronicItemView_ScanBarcode')}
              </Typography>
            </Grid>
            <Grid item>
              <Barcode className={classes.iconLabel} />
            </Grid>
          </Grid>
          <Grid item>
            <BaseButton
              buttonType='white'
              className={classes.cancelButton}
              onClick={props.onClose}
              data-testid='electronic-item-cancel-button'
            >
              {t('Cancel')}
            </BaseButton>
          </Grid>
        </Grid>
        <Grid item className={classes.keypad}>
          <Keypad
            keyboardId='electronic-item'
            visible={true}
            topLabelText={TARE_WEIGHT_KEYPAD_TOP_LABEL}
            submitButton={keypadSubmitButton}
            disableQuantity={true}
            disableManualWeight={true}
            disableSubmitWhenNoInput={true}
            keypadTestIdPrefix='electronic-item-'
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export interface IElectronicItemProps {
  onClose: () => void;
  onSubmit: (serial: string) => void;
}
export default ElectronicItemModal;
